module.exports = {
  findPwd: {
    find: '找回密码',
    userName: '手机号或邮箱',
    error_userName_1: '请输入手机号或邮箱',
    error_userName_2: '该号码未绑定任何投影仪账号',
    error_userName_3: '该邮箱未绑定任何投影仪账号',
    get_code: '发送验证码',
    get_code_tip: '点击发送验证码',
    get_code_tip_re: '秒后重新发送',
    code: '验证码',
    error_code_1: '请输入验证码',
    error_code_2: '获取验证码次数已达今日上限，请明天再试！',
    error_code_3: '验证码错误',
    error_code_4: '验证码已经发送，10分钟内有效',
    error_code_5: '验证码获取频率频繁，请稍后再试',
    error_phone: '请输入正确账号',
    next: '下一步',
    input_password: '输入新密码',
    repeat_new_password: '确认新密码',
    new_password_error: '两次密码不一致',
    submit_new_password: '提交',
    success_relogin: '密码重置成功，请重新登录',
    button_relogin: '重新登录',
    password_set: '8-20位字母及数字组合密码',
    account_info: '账号信息',
    current_account: '当前绑定账号',
    change_password: '修改密码',
    phone_find: '通过绑定手机或邮箱找回账号密码',
    not_bind_starryHub: '未绑定任何投影仪账号',
    expired: '已过期',
    account_type: '请选择账号类型',
    starryHub_account: '投影仪账号',
    czur_cloud_account: '成者云账号'
  },
  tips: {
    timeout: '请求超时!',
    internalError: '服务器内部异常！',
    networkError: '网络连接异常!',
    connectError: '连接出错(',
    errorStatus: '请求错误(400)'
  },
  index: {
    loginText: '成者云',
    accountNumber: '成者云账号/投影仪账号',
    password: '密码',
    forgetPwd: '忘记密码',
    register: '新用户注册',
    errorTip: '用户名/密码错误',
    selectFunction: '请选择对应功能',
    unactivated: '用户未激活',
    notebook: '笔记本',
    mobileTip: '该网页是专为PC用户设计开发的云服务',
    youCan: '您可以：',
    mobileTextOne: '手机用户请下载“成者CZUR”APP',
    mobileTextTwo: '或使用PC浏览该网页',
    downloadApp: '下载APP',
    countryError: '该账号为非本地区注册，是否跳转至注册地区获取相关服务？',
    countryGo: '确定'
  },
  list: {
    noFile: '还没有文件',
    time: '时间',
    category: '分类',
    accountCenter: '账户中心',
    logOut: '退出登录',
    thisday: '当日',
    items: '项',
    total: '共',
    feedback: '建议反馈',
    used: '已使用',
    back: '返回',
    loading: '加载中...',
    loaded: '已加载完毕',
    feedbackPlaceholder: '请输入反馈信息（300字以内）',
    submit: '提交',
    cancel: '取消',
    feedbackSuccess: '意见反馈成功！',
    label: '标签',
    empty: '空'
  },
  player: {
    flatSinglePage: '平整单张',
    curvePage: '左右曲面',
    color: '彩色',
    grayscale: '灰度',
    bw: '黑白',
    pattern: '证件底纹',
    autoEnhance: '自动优化',
    copyToClipboard: '已复制至剪切板',
    noOcrResult: '无识别结果',
    ocrTip: '请在成者CZUR APP里进行手写体识别'
  },
  operation: {
    selected: '已选',
    selectAllLoaded: '全选已加载',
    deselectAll: '取消选择',
    moveFiles: '移动',
    share: '分享',
    exportPDF: '导出PDF',
    download: '下载',
    delete: '删除',
    moveToFolder: '移动至文件夹',
    rename: '重命名',
    confirm: '确认',
    msg: '提示',
    moveFilesSuccess: '文件移动成功',
    floderName: '请输入文件夹名称',
    shareTimeLimit: '分享链接期限',
    hours: '小时',
    days: '天',
    createLink: '创建链接',
    shareLink: '分享链接',
    password: '密码',
    copy: '复制',
    createPDF: '创建PDF',
    pdfName: '请输入PDF名称',
    pdfSet: 'PDF设置',
    pdfSize: 'PDF尺寸',
    autoAdjustment: '自适应',
    pdfDirection: 'PDF方向',
    vertical: '纵向',
    horizontal: '横向',
    pdfQuality: 'PDF质量',
    standard: '标准',
    maximum: '最优',
    pdfCreated: '创建PDF成功',
    done: '完成'
  },
  share: {
    shareLink: '成者云ET分享链接：',
    expire: ' 过期时间：',
    shared: '的分享',
    enterPassword: '请输入提取码',
    wrongPassword: '提取码错误',
    fileExpired: '文件已过期',
    fileDelete: '文件已删除',
    package: '打包中...',
    shareNotebookLink: '成者云笔记本分享链接：'
  },
  device: {
    deviceList: '设备列表',
    noDevice: '暂无设备',
    apply: '使用',
    using: '使用中',
    bindDeviceTips: '请使用“成者CZUR”App，扫描设备底座下的二维码，进行绑定添加ET设备',
    gotIt: '知道了',
    isUsingDevice: '正在使用此设备',
    unbindDevice: '解绑设备',
    searchAccount: '搜索成者账号',
    searchMember: '搜索成员',
    transferAdministrator: '转让管理员',
    deleteMember: '删除成员',
    shareDevice: '开放此设备',
    shareDeviceTips: '开放设备后，其它用户可以通过扫描ET底座的二维码来使用此设备，但你仍是管理员。',
    noMember: '还没有其他成员',
    unbindDeviceTips: '解绑后，所有成员将无法使用此设备，成者云账号和存储的资料会保留。重启ET设备后生效',
    unbind: '解绑',
    noAccount: '账号不存在',
    addMember: '添加成员',
    administrator: '管理员',
    added: '已添加',
    cancelTransfer: '取消转让',
    conformTransfer: '确认转让',
    ifTransferadministrator: '确认将管理员转让给',
    cancelDelete: '取消删除',
    confirmDelete: '确认删除',
    ifDeleteMember: '确认删除成员',
    and: '等',
    others: '人',
    needFirmwareUpgrade: '需固件升级',
    statement: '声明',
    upgradeTest: '由于云服务升级改造，您的ET需升级固件',
    upgradeTestOne: '1.将ET开机，并通过USB连接电脑；',
    upgradeTestTwo: '2.安装并打开CZUR Scanner 软件；',
    upgradeTestThree: '3.进入软件的系统设置-固件版本-点击升级，按软件提示完成升级；',
    upgradeTestFour: '4.断开USB线进入Wi-Fi模式，确定ET联网成功，刷新App即可使用。'
  }
}



// WEBPACK FOOTER //
// ./src/common/lang/zh_CN.js